import {SimpleBlueButton} from '../button'
import {useState} from 'react'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'

const TutorialActions = ({skipCallback, actions}) => {
    const text = useNamespaceTranslations('tutorial')
    const [activeActionIndex, setActiveActionIndex] = useState(0)
    const changeStep = () => {
        actions[activeActionIndex].callBack()
        setActiveActionIndex(prev => prev + 1)
    }
    return (
        <div className="tutorial-actions">
            <div className="info">
                {actions[activeActionIndex].text}
            </div>
            <div className="button-group">
                <span className="skip-link" onClick={skipCallback}>{text.skip}</span>
                <SimpleBlueButton id="next-btn" className="small-padding"
                    onClick={changeStep}>{text.next}</SimpleBlueButton>
            </div>
        </div>
    )
}

export default TutorialActions
